//
//  Password Reset Actions
//  CXA Apollo
//
//  Created on 24/11/2016.
//  Copyright (c) 2016 CXA. All rights reserved.
//
//  payloads of information that send data to our store.
//

import { SubmissionError } from "redux-form";
import api from "../api/flexapi";
import { showToast } from "actions/toastActions";
import messages from "components/messagesDescription";
// Type of action being performed - Password Reset
export const passwordResetSubmitBegin = "passwordResetSubmitBegin";
export const passwordResetSubmitSuccess = "passwordResetSubmitSuccess";
export const passwordResetSubmitFailed = "passwordResetSubmitFailed";


// Call API to load module data
export function passwordReset(data) {  
  // Return thunk middleware
  return dispatch => {
    dispatch({ type: passwordResetSubmitBegin, payload: null });

    return api
      .resetPassword(data)
      .then(response => {
        dispatch(showToast({ message: "Password changed successfully. You may now log in using your new password." }));
        dispatch({ type: passwordResetSubmitSuccess, payload: response });
      })
      .catch(err => {
        if (err.response && err.response.body) {
          if(err.response.body.resultMessage !== undefined){
            dispatch(showToast({ message: err.response.body.resultMessage}));
          } else {
            dispatch(showToast({ message: err.response.body}));
          }
        }
        dispatch({
          type: passwordResetSubmitFailed,
          payload: err.response ? err.response : err,
        });
        throw new SubmissionError({
          _error: err.response ? err.response.body.resultMessage : err,
        });
      });
  };
}



// WEBPACK FOOTER //
// ./actions/passwordResetActions.jsx